import { useState } from "react";
import { Link } from "react-router-dom";
import { useLocation } from "react-router-dom";
import "../styles/header.css";
import LogoImage from "../assets/logo.png"; // Adjust the path as needed

function Header() {
  const [mobileNavOpen, setMobileNavOpen] = useState(false);

  // Optional: close menu on navigation
  const handleNavClick = () => setMobileNavOpen(false);

  const location = useLocation();
  function handleNavOrScroll(path) {
    // If already on the path, scroll to top
    if (location.pathname === path) {
      window.scrollTo({ top: 0, behavior: "smooth" });
      setMobileNavOpen(false);
    }
    // Else navigate as normal, let <Link> handle it
  }
  return (
    <header className="header">
      <div className="header-container">
        <Link
          to="/"
          onClick={(e) => {
            if (location.pathname === "/") {
              e.preventDefault();
              window.scrollTo({ top: 0, behavior: "smooth" });
            }
            handleNavClick();
          }}
        >
          <img src={LogoImage} alt="Serenity Logo" className="logo" />
        </Link>

        {/* Hamburger for mobile */}
        <button
          className="nav-hamburger"
          aria-label="Toggle navigation"
          onClick={() => setMobileNavOpen((v) => !v)}
        >
          {/* Simple hamburger icon */}
          <span />
          <span />
          <span />
        </button>

        {/* Desktop nav */}
        <nav className="nav-links">
          <Link
            to="/"
            onClick={(e) => {
              if (location.pathname === "/") {
                e.preventDefault();
                window.scrollTo({ top: 0, behavior: "smooth" });
              }
              handleNavClick();
            }}
          >
            Home
          </Link>
          <Link
            to="/about"
            onClick={(e) => {
              if (location.pathname === "/about") {
                e.preventDefault();
                window.scrollTo({ top: 0, behavior: "smooth" });
              }
              handleNavClick();
            }}
          >
            About
          </Link>
          <Link
            to="/services"
            onClick={(e) => {
              if (location.pathname === "/services") {
                e.preventDefault();
                window.scrollTo({ top: 0, behavior: "smooth" });
              }
              handleNavClick();
            }}
          >
            Services
          </Link>
          <Link
            to="/blogs"
            onClick={(e) => {
              if (location.pathname === "/blogs") {
                e.preventDefault();
                window.scrollTo({ top: 0, behavior: "smooth" });
              }
              handleNavClick();
            }}
          >
            Blogs
          </Link>
          <Link
            to="/contact"
            className="contact-button"
            onClick={(e) => {
              if (location.pathname === "/contact") {
                e.preventDefault();
                window.scrollTo({ top: 0, behavior: "smooth" });
              }
              handleNavClick();
            }}
          >
            Contact Us{" "}
            <span className="arrow-icon" aria-hidden="true">
              <svg
                width="12"
                height="12"
                viewBox="0 0 12 12"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M4 3L8 6L4 9"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </span>
          </Link>
        </nav>
      </div>

      {/* Mobile nav overlay */}
      <nav className={`mobile-nav${mobileNavOpen ? " open" : ""}`}>
        <Link
          to="/"
          onClick={(e) => {
            if (location.pathname === "/") {
              e.preventDefault();
              window.scrollTo({ top: 0, behavior: "smooth" });
            }
            handleNavClick();
          }}
        >
          Home
        </Link>
        <Link
          to="/about"
          onClick={(e) => {
            if (location.pathname === "/about") {
              e.preventDefault();
              window.scrollTo({ top: 0, behavior: "smooth" });
            }
            handleNavClick();
          }}
        >
          About
        </Link>
        <Link
          to="/services"
          onClick={(e) => {
            if (location.pathname === "/services") {
              e.preventDefault();
              window.scrollTo({ top: 0, behavior: "smooth" });
            }
            handleNavClick();
          }}
        >
          Services
        </Link>
        <Link
          to="/blogs"
          onClick={(e) => {
            if (location.pathname === "/blogs") {
              e.preventDefault();
              window.scrollTo({ top: 0, behavior: "smooth" });
            }
            handleNavClick();
          }}
        >
          Blogs
        </Link>
        <Link
          to="/contact"
          onClick={(e) => {
            if (location.pathname === "/contact") {
              e.preventDefault();
              window.scrollTo({ top: 0, behavior: "smooth" });
            }
            handleNavClick();
          }}
        >
          Contact Us{" "}
          <span className="arrow-icon" aria-hidden="true">
            <svg
              width="12"
              height="12"
              viewBox="0 0 12 12"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M4 3L8 6L4 9"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </span>
        </Link>
      </nav>

      {/* Backdrop for mobile menu */}
      {mobileNavOpen && (
        <div className="mobile-nav-backdrop" onClick={handleNavClick} />
      )}
    </header>
  );
}

export default Header;
